//import images
import imgHomeSvg from '../../assets/icons/tabs/Home.svg'
import imgHomeSvgHover from '../../assets/icons/tabs/HomeHover.svg'


import imgProjectSvg from '../../assets/icons/tabs/projects.svg'
import imgProjectSvgHover from '../../assets/icons/tabs/projectsHover.svg'

import imgGameSvg from '../../assets/icons/tabs/game.svg'
import imgGameSvgHover from '../../assets/icons/tabs/gameHover.svg'

import imgAboutSvg from '../../assets/icons/tabs/about.svg'
import imgAboutSvgHover from '../../assets/icons/tabs/aboutHover.svg'


export const iconsImage = {
  homeIcon:{
    static:imgHomeSvg,
    hover: imgHomeSvgHover,
  },

  projectIcon: {
    static: imgProjectSvg,
    hover: imgProjectSvgHover,
  },
  gameIcon: {
    static: imgGameSvg,
    hover: imgGameSvgHover,
  },

  aboutIcon:{
    static: imgAboutSvg,
    hover: imgAboutSvgHover,
  }
  
}